import Star from "../../../assets/svgs/Star";
import User from "../../../assets/svgs/User";
import VerticalDotted from "../../../assets/svgs/VerticalDotted";

function UserSingleMessage({ isAuthUser, image, message, messages }) {
  return (
    <div className="chat-message">
      <div
        className={`flex items-end ${isAuthUser ? "flex-col-reverse" : "  "}`}
      >
        <div className="flex flex-col space-y-2 text-xs max-w-xs mx-2 order-2 items-start">
          {messages?.map((msg, i) => (
            <div key={i}>
              <span
                className={`${
                  isAuthUser
                    ? " bg-gray-200 text-gray-800 "
                    : " bg-gradient-to-tr from-pink-400 to-pink-600 text-white "
                } px-4 py-2 rounded-lg inline-block rounded-bl-none shadow`}
              >
                {msg}
              </span>
            </div>
          ))}

          {message && (
            <div>
              <span
                className={`${
                  isAuthUser
                    ? " bg-gray-200 text-gray-800 "
                    : " bg-gradient-to-tr from-pink-400 to-pink-600 text-white "
                } px-4 py-2 rounded-lg inline-block rounded-bl-none shadow`}
              >
                {message}
              </span>
            </div>
          )}
        </div>
        <img className="w-5 h-5 mt-1 rounded-full" src={image} />
      </div>
    </div>
  );
}

export default function MessagingUI() {
  return (
    <div
      style={{ height: "600px" }}
      className="flex-1 bg-white justify-between flex flex-col shadow-lg py-2"
    >
      <div className="flex sm:items-center justify-between px-2 pb-2 border-b-2 border-gray-200">
        <div className="relative flex items-center space-x-4">
          <div className="relative">
            <span className="absolute text-green-500 -right-1 -bottom-1">
              <svg width={20} height={20}>
                <circle cx={7} cy={7} r={7} fill="currentColor" />
              </svg>
            </span>
            <img
              src="https://images.unsplash.com/photo-1549078642-b2ba4bda0cdb?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=3&w=144&h=144"
              alt=""
              className="w-8 sm:w-12 h-8 sm:h-12 rounded-full"
            />
          </div>
          <div className="flex flex-col leading-tight">
            <div className="text-xl mt-1 flex items-center">
              <span className="text-gray-700 mr-3">Anderson Vanhron</span>
            </div>
            <span className="text-sm text-gray-600">Active</span>
          </div>
        </div>

        <div className="flex items-center text-gray-500 space-x-4">
          <button>
            <Star />
          </button>
          <button>
            <User />
          </button>
          <button>
            <VerticalDotted />
          </button>
        </div>
      </div>

      {/* Messages */}
      <div
        id="messages"
        style={{ height: "450px" }}
        className="overflow-y-auto flex flex-col space-y-4 p-3 scrollbar-thumb-blue scrollbar-thumb-rounded scrollbar-track-blue-lighter scrollbar-w-2 scrolling-touch"
      >
        <UserSingleMessage
          image="https://images.unsplash.com/photo-1549078642-b2ba4bda0cdb?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=3&w=144&h=144"
          message="I've update the description so it's more obviously now"
        />

        <UserSingleMessage
          isAuthUser={true}
          image="https://images.unsplash.com/photo-1590031905470-a1a1feacbb0b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=3&w=144&h=144"
          message="Any updates on this issue? I'm getting the same error when trying to install devtools. Thanks"
        />
        <UserSingleMessage
          image="https://images.unsplash.com/photo-1549078642-b2ba4bda0cdb?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=3&w=144&h=144"
          messages={[
            "I've update the description so it's more obviously now",
            "Command was run with root privileges. I'm sure about that.",
          ]}
        />
         

        <UserSingleMessage
          isAuthUser={true}
          image="https://images.unsplash.com/photo-1590031905470-a1a1feacbb0b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=3&w=144&h=144"
          message="Any updates on this issue? I'm getting the same error when trying to install devtools. Thanks"
        />
        <UserSingleMessage
          image="https://images.unsplash.com/photo-1549078642-b2ba4bda0cdb?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=3&w=144&h=144"
          messages={[
            "I've update the description so it's more obviously now",
            "Command was run with root privileges. I'm sure about that.",
          ]}
        />
      </div>

      <div className="border-gray-200 px-4 py-3 mb-2 sm:mb-0">
        <div className="relative flex">
          <span className="flex absolute inset-y-0 items-center">
            <button
              type="button"
              className="inline-flex items-center justify-center rounded-full h-12 w-12 transition duration-500 ease-in-out text-gray-500 hover:bg-gray-300 focus:outline-none"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                className="h-6 w-6 text-gray-600"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z"
                />
              </svg>
            </button>
          </span>
          <input
            type="text"
            placeholder="Your message"
            className="w-full focus:outline-none focus:placeholder-gray-400 text-gray-800 placeholder-gray-600 pl-12 bg-gray-100 shadow-md rounded-full py-3"
          />
          <div className="absolute right-2 items-center inset-y-0 flex">
            <button
              type="button"
              className="sm:hidden lg:inline-flex items-center justify-center rounded-full h-10 w-10 transition duration-500 ease-in-out text-gray-500 hover:bg-gray-300 focus:outline-none"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                className="h-6 w-6 text-gray-600"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"
                />
              </svg>
            </button>
            <button
              type="button"
              className="hidden lg:inline-flex items-center justify-center rounded-full h-10 w-10 transition duration-500 ease-in-out text-gray-500 hover:bg-gray-300 focus:outline-none"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                className="h-6 w-6 text-gray-600"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"
                />
              </svg>
            </button>
            <button
              type="button"
              className="items-center justify-center rounded-full h-10 w-10 transition duration-500 ease-in-out text-gray-500 hover:bg-gray-300 focus:outline-none"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                className="h-6 w-6 text-gray-600"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </button>
            <button
              type="button"
              className="flex items-center justify-center rounded-full w-9 h-9 shadow-md bg-gradient-to-tr from-pink-500 to-pink-600 text-white focus:outline-none"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                className="h-4 w-4 ml-2 transform rotate-90"
              >
                <path d="M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 001.169 1.409l5-1.429A1 1 0 009 15.571V11a1 1 0 112 0v4.571a1 1 0 00.725.962l5 1.428a1 1 0 001.17-1.408l-7-14z" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
